// The register's wide presentation. The sortable column headers are the sort control, and
// aria-sort is what says which column is sorted.

import { CELLS } from './registerCells.jsx';

const WHEN = new Set(['last_activity', 'created']);

// `columns` is the register's set: with the deal flow on, the stage in the state's place.
export default function DealTable({ columns, deals, query, onSort }) {
  return (
    <div className="table-scroll">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((column) => (column.sortable ? (
              <th key={column.key} aria-sort={ariaSort(query, column.key)}>
                <button type="button" onClick={() => onSort(column.key)}>
                  {column.label}{sortMarker(query, column.key)}
                </button>
              </th>
            ) : (
              // Not a button: a dead header button says the column sorts.
              <th key={column.key} className="plain">{column.label}</th>
            )))}
          </tr>
        </thead>
        <tbody>
          {deals.map((deal) => (
            <tr key={deal.pre_deal_id}>
              {columns.map((column) => (
                <td key={column.key} className={WHEN.has(column.key) ? 'when' : undefined}>
                  {CELLS[column.key](deal)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function ariaSort(query, key) {
  if (query.sort !== key) return 'none';
  return query.direction === 'asc' ? 'ascending' : 'descending';
}

function sortMarker(query, key) {
  if (query.sort !== key) return '';
  return query.direction === 'asc' ? ' ↑' : ' ↓';
}
